<template>
	<div style="position: relative;">
		<el-upload drag class="" style="margin-bottom: 10px;" :disabled="disabled" action="upload.php"
			:on-preview="handlePreview" :on-remove="onRemove" :before-remove="beforeRemove" :multiple="multiple"
			:limit="limit" :on-exceed="handleExceed" :file-list="value" :on-success="onSuccess" :on-change="onChange"
			:on-error="onError" :http-request="httpRequest" :before-upload="beforeUpload" list-type="picture-card">
			<div style="width: 100%;height: 100%;" slot="file" slot-scope="{file}">
				<img class="el-upload-list__item-thumbnail" :src="file.url">
				<el-tooltip class="item" effect="dark" :content="file.name" placement="bottom">
					<div class="filethumb full">
						<div class="el-upload-list__item-actions full">
							<div class="full flex"
								style="flex-direction: row;flex-wrap: wrap;align-items: flex-end;justify-content: center;">
								<span class="icon" style="margin: 6px;" @click="preview(file)">
									<i class="el-icon-zoom-in"></i>
								</span>
								<span class="icon" style="margin: 6px;" @click="download(file)">
									<i class="el-icon-download"></i>
								</span>
								<span class="icon" style="margin: 6px;" @click="print(file)">
									<i class="el-icon-printer"></i>
								</span>
								<template v-if="!readonly && !disabled">
									<!-- 									<div style="position: absolute;right: 0px;top: 0px;"
												class="icon" @click="handleRemove(file)">
												<i class="el-icon-circle-close"></i>
											</div> -->
									<span class="icon" style="margin: 6px;" @click="rename(file)">
										<i class="el-icon-edit"></i>
									</span>
									<span class="icon" style="margin: 6px;" @click="handleRemove(file)">
										<i class="el-icon-delete"></i>
									</span>

								</template>
							</div>
						</div>
					</div>
				</el-tooltip>
			</div>
			<div class="button" v-if="!readonly && !disabled && canupload">
				<template v-if="!uploadloading">
					<div class="full flex"
						style="font-size: 12px;flex-direction: row;align-items: center;justify-content: center;"
						ref="uploadbutton">
						点击、拖拽上传</div>
				</template>
				<el-button v-else class="full" type="text" icon="el-icon-loading" size="mini"></el-button>
			</div>
			<div class="full" @click="hasCarmera" style="cursor: pointer;"></div>
		</el-upload>
		
	</div>
</template>
<style scoped>
	.filethumb {
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	.button {
		position: relative;
		height: 100%;
	}
</style>
<script>
	export default {
		props: {
			multiple: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			limit: {
				type: Number,
				default: () => {
					return 100
				}
			},
			value: {
				default: (e) => {
					return e ? e : []
				}
			},
			disabled: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			readonly: {
				default: () => {
					return false
				}
			},
			canupload: {
				default: () => {
					return true
				}
			},
			uploadloading: {
				default: () => {
					return false
				}
			},

		},
		data() {
			return {

			}
		},
		created() {


		},
		mounted() {


		},
		watch: {
			// value(val){
			// 	let file = val?val:[]
			// 	file.forEach((item)=>{
			// 		this.createIcon(item)
			// 	})				
			// }
		},
		computed: {

		},
		methods: {
			hasCarmera(e) {
				e.stopPropagation()
				if (window.carmera && !window.carmera.closed) {
					// this.$store.state.carmera
					window.carmera.postMessage({
						type: 'getimg',
					}, '*');
					window.addEventListener('message', (event) => {
						if (event.data.type === 'canvas') {
							const base64 = event.data.data
							let blob = this.dataURLtoBlob(base64)
							let file = new File([blob], 'image.png', {
								type: 'image/png'
							}); // 创建 File 对象
							//console.log(file)
							this.httpRequest({file:file})
						}
					}, {
						once: true
					})
				} else {
					this.$refs.uploadbutton.click()
					
				}

			},
			dataURLtoBlob(dataURL) {
				let arr = dataURL.split(','); // 分割 Base64 字符串
				let mime = arr[0].match(/:(.*?);/)[1]; // 提取 MIME 类型
				let bstr = atob(arr[1]); // 解码 Base64 数据
				let n = bstr.length;
				let u8arr = new Uint8Array(n); // 创建 Uint8Array
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n); // 将字符转换为字节
				}
				return new Blob([u8arr], {
					type: mime
				}); // 返回 Blob 对象
			},
			handlePreview(e) {
				this.$emit('handlePreview', e)
			},
			onRemove(e) {
				this.$emit('onRemove', e)
			},
			beforeRemove(e) {
				this.$emit('beforeRemove', e)
			},
			handleExceed(e) {
				this.$emit('handleExceed', e)
			},
			onSuccess(e) {
				this.$emit('onSuccess', e)
			},
			onChange(e) {
				this.$emit('onChange', e)
			},
			onError(e) {
				this.$emit('onError', e)
			},
			httpRequest(e) {
				this.$emit('httpRequest', e)
			},
			beforeUpload(e) {
				this.$emit('beforeUpload', e)
			},
			preview(file) {
				this.$emit('preview', file)
			},
			download(file) {
				this.$emit('download', file)
			},
			print(file) {
				this.$emit('print', file)
			},
			rename(file) {
				this.$emit('rename', file)
			},
			handleRemove(file) {
				this.value.forEach((item, index) => {
					if (item.uid == file.uid) {
						this.value.splice(index, 1)
					}
				})
				//console.log(this.value)
				this.$emit('handleRemove', file)
			},
		}
	}
</script>